export const handleRequestWithMock = async <T>(call: () => Promise<T>, mockData: T) => {
    return process.env.APP_SSR_MOCK === 'true' ? mockData : await call();
};
